import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OutreachLocation from "./OutreachLocation";

@Model()
class OrganisationOutreachLocationExclusion extends ApplicationRecord {
  static jsonapiType = "organisation_outreach_location_exclusions";

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @BelongsTo() outreachLocation: OutreachLocation;

  @Attr() outreachLocationId: number;
}

export default OrganisationOutreachLocationExclusion;
